import axios from 'axios';
// config
// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: 'https://ggbmhipeqg.execute-api.eu-west-3.amazonaws.com/dev/' });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
